export const SUGGESTIONS = [
  "Create a workflow to flag high-risk transactions",
  "Generate rules for approving loans over $10,000",
  "Reject users under age 18",
  "Automatically approve expense claims under $500 with valid receipts",
  "Route vendor contract renewals over $100,000 to legal for review",
  "Deny funding requests missing mandatory risk assessment form",
  "Trigger executive review for projects exceeding 20% budget variance",
  "Prioritize grant applications with community impact score above 90",
  "Require board approval for policy changes affecting more than 1,000 users",
  "Escalate decisions on hiring executives to C-level review queue",
  "Auto-approve travel requests within policy guidelines and budget limits",
  "Send performance alerts if KPIs fall below threshold for 3 consecutive months",
  "Block investment decisions that conflict with ESG policy filters",
]
